import { render } from "./Robot.vue?vue&type=template&id=946278a4&scoped=true"
import script from "./Robot.vue?vue&type=script&lang=js"
export * from "./Robot.vue?vue&type=script&lang=js"

import "./Robot.vue?vue&type=style&index=0&id=946278a4&lang=less&scoped=true"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946278a4"]])

export default __exports__